import { render, staticRenderFns } from "./NonFixedTab.vue?vue&type=template&id=410797a9&"
import script from "./NonFixedTab.vue?vue&type=script&lang=js&"
export * from "./NonFixedTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports